<template lang="pug">
  .app
    app-header
    .app__scroll
      vue-scroll
        .app__wrapper
          .container
            router-view
</template>

<script>
import AppHeader from '@/components/layouts/app-header/AppHeader'

export default {
  name: 'App',

  components: {
    AppHeader
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .app {
    &__scroll {
      height: 100vh;
      padding-top: 7rem;
    }

    &__wrapper {
      padding-top: 4rem;
      padding-bottom: 4rem;

      @include mobile {
        padding: 2.5rem 0;
      }
    }
  }
</style>
